<template>
  <CardWithTitle
    :item-id="itemId"
    :items="items"
    :map-keys="mapKeys"
    :request-status="requestStatus"
    :options-data="cardOptions"
    :has-custom-filter="hasCustomFilter"
    :has-data-to-export="hasDataToExport"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <template #top-right-slot>
      <template v-if="hasCustomFilter">
        <DsButton
          v-tooltip="filterButton"
          color="tertiary"
          name="filter"
          :icon="true"
          @click="openFilter"
        />
      </template>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
      <DsButton
        v-if="hasInfo"
        v-tooltip="infoLabel"
        color="tertiary"
        name="questions"
        :icon="true"
        @click="openDialog"
      />
    </template>
  </CardWithTitle>
</template>

<script>

import CardWithTitle from '@/components/cards/models/CardWithTitle';
import exportModel from '@/mixins/export-model';
import cardsModel from '@/mixins/cards-model';
import { DsButton } from '@ds/components';
import Badge from '@/components/Badge';
import { remapFieldKeys } from '@/utils/formatter';
import { saveAs } from 'file-saver';
import XLSX from 'xlsx';

export default {
  name: 'MultibarChart',
  components: {
    CardWithTitle,
    DsButton,
    Badge,
  },
  mixins: [
    cardsModel,
    exportModel,
  ],
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    requestStatus: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    hasCustomFilter: {
      type: Boolean,
      default: false,
    },
    hasInfo: {
      type: Boolean,
      default: true,
    },
    hasDataToExport: {
      type: Boolean,
      default: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    openDialog: {
      type: Function,
      default: () => {},
    },
    openFilter: {
      type: Function,
      default: () => {},
    },
    mapKeys: {
      type: Object,
      default: null,
    },
  },
  computed: {
    exportLabel() {
      return this.$t('components.OperatorsLogs.export');
    },
    infoLabel() {
      return this.$t('components.OperatorsLogs.infoLabel');
    },
    filterButton() {
      return this.$t('components.OperatorsLogs.filterLabel');
    },
    cardOptions() {
      if (this.hasDataToExport) {
        return this.baseCardOptions.concat(this.exportWithXLSXOptionsData(this.items)).sort((actualOption, prevOption) => this.sortMenuOptions(actualOption, prevOption));
      }
      return this.baseCardOptions;
    },
  },
  methods: {
    exportWithXLSXOptionsData(items) {
      const exportExtensionOptions = this.exportExtensions.map((extension, index) => (
        {
          order: index + 1,
          name: extension.type,
          function: () => (this.exportComponent(extension, true)),
        }
      ));

      exportExtensionOptions.push({
        order: exportExtensionOptions.length + 1,
        name: 'XLSX',
        function: () => (this.exportComponentXLSX(items)),
      });

      return [
        {
          order: 5,
          name: this.$t('mixins.exportModel.label.exportLabel'),
          iconname: 'download',
          function: () => ([]),
          child: exportExtensionOptions,
          trackName: 'ST CardMenu Export Click',
          trackProperties: {
            title: this.card?.props?.title,
            widget: this.card?.component,
          },
          isExpandedModeOption: true,
        },
      ];
    },
    exportComponentXLSX(items) {
      const translatedData = remapFieldKeys(this.mapKeys, items);
      const ws = XLSX.utils.json_to_sheet(translatedData);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(blob, `${this.title}.xlsx`);
    },
  },
};
</script>

